(ns practitest.frontend.vsadmin.events
  (:require
    [goog.object :as gobj]
    [re-frame.core :as re-frame]
    [practitest.frontend.common.logger :as log]
    [ajax.core :as ajax]
    [day8.re-frame.http-fx]
    [practitest.frontend.vsadmin.db :as db]))

(def common-interceptors
  [re-frame/trim-v])

(re-frame/reg-event-fx
 ::initialize-db
 common-interceptors
 (fn [_ [options]]
   (log/debug ::initialize-db options)

   (.addEventListener js/window "popstate"
                      (fn [e]
                        (log/info "popstate" e)
                        (re-frame/dispatch
                         [::restore-state
                          (js->clj (.-state e) :keywordize-keys true)])))
   {:db
    (cond-> (assoc db/default-value :options options)
      (= "vsadmin" (:view options))
      (assoc :x-data (:x_data options))
      (= "vsadmin" (:view options))
      (assoc :y-data (:y_data options))
      (= "vsadmin" (:view options))
      (assoc :x-trend (:x_trend options))
      (= "vsadmin" (:view options))
      (assoc :y-trend (:y_trend options)))}))
